import { useActiveCoachReviewsContext } from "./useActiveCoachReviewsContext";
import { useQuery } from "@tanstack/react-query";

export const useGetReviews = () => {
	const { gameId, promises } = useActiveCoachReviewsContext();

	if (!promises) {
		throw new Error("Coach review promises are not available");
	}

	return useQuery({
		queryKey: ["coachReviews", gameId], // TODO: Move into key factory
		queryFn: () => promises.getCoachReviews({ id: gameId }),
		staleTime: 1000 * 60, // 1 minute
	});
};
